import { makeMutationHook, makeQueryHook } from "utils/apolloUtils";

import {
  GetEventTemplates,
  GetEventTemplatesVariables,
  GetEventTemplate,
  GetEventTemplateVariables,
} from "./__generated__/queries";
import { GET_EVENT_TEMPLATES, GET_EVENT_TEMPLATE } from "./queries";
import {
  CreateEventTemplate,
  CreateEventTemplateVariables,
  UpdateEventTemplate,
  UpdateEventTemplateVariables,
} from "./__generated__/mutations";
import { CREATE_EVENT_TEMPLATE, UPDATE_EVENT_TEMPLATE } from "./mutations";

export const useEventTemplateCreateMutation = makeMutationHook<
  CreateEventTemplate,
  CreateEventTemplateVariables
>(CREATE_EVENT_TEMPLATE);

export const useEventTemplateUpdateMutation = makeMutationHook<
  UpdateEventTemplate,
  UpdateEventTemplateVariables
>(UPDATE_EVENT_TEMPLATE);

export const useEventTemplateListQuery = makeQueryHook<
  GetEventTemplates,
  GetEventTemplatesVariables
>(GET_EVENT_TEMPLATES);

export const useEventTemplateDetailsQuery = makeQueryHook<
  GetEventTemplate,
  GetEventTemplateVariables
>(GET_EVENT_TEMPLATE);
